export default __webpack_public_path__ + "locales/vi/Settings.json?hash=d9c74cc4d3d08a857fc78fd858242a49";